import l from "react";
import u from "classnames";
import c from "./stepButton.module.scss.js";
function f(t) {
  const {
    className: o,
    textColor: e = "#000",
    backgroundColor: r = "#efefef",
    disabled: s,
    buttonProps: a,
    children: n
  } = t;
  return /* @__PURE__ */ l.createElement(
    "button",
    {
      "data-testid": "step-button",
      ...a,
      type: "button",
      disabled: s,
      style: {
        "--textColor": e,
        "--backgroundColor": r
      },
      className: u(c.stepButton, o)
    },
    n
  );
}
export {
  f as StepButton
};
//# sourceMappingURL=StepButton.js.map
